import * as moment from 'moment';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';
import { User } from '../../shared/models/User';
import { UserService } from '../../shared/services/user.service';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { TeamUser } from 'app/shared/services/challenge.service';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
})
export class StatsComponent implements OnInit, OnDestroy {
  user: User;

  // User data of currently active challenge
  teamUser: TeamUser;

  // Whether the user is member in a running team challenge and thus the normal leaderboard should not be displayed
  isMemberInRunningChallenge = false;

  hideCompanyScoreList = false;

  // check if achievments are activated for company
  isAchievementsActivated = false;

  // check if achievements limit is activated
  isAchievementsLimitActivated = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private userService: UserService, private router: Router, private challengeService: ChallengeService) {
    // Scroll to top of page upon navigation end to make sure challenge section is displayed
    this.router.events.takeUntil(this.ngUnsubscribe).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  public async getCompanyData() {
    const companyData: any = await this.userService.getCompany();
    this.hideCompanyScoreList = companyData.hideCompanyScoreList;
    this.isAchievementsActivated = companyData.activateAchievements;
    this.isAchievementsLimitActivated = companyData.activateAchievementsLimit;
  }

  public async ngOnInit() {
    await this.getCompanyData();

    this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe((user) => {
      if (!user) {
        return;
      }
      this.user = user;
    });

    // Only display normal company leaderboard if user does not take part in a team challenge
    combineLatest(this.challengeService.displayedChallenge, this.challengeService.team, this.challengeService.teamUser)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(([challenge, team, user]) => {
        this.teamUser = user;
        if (
          // If a challenge is currently running and the user is member of a team
          challenge &&
          moment(challenge.start).isBefore(moment()) &&
          moment(challenge.end).isAfter(moment()) &&
          user &&
          user.membershipStatus === 'member' &&
          team &&
          team.userGroups.members.length >= challenge.minimalTeamMembers
        ) {
          this.isMemberInRunningChallenge = true;
        } else {
          this.isMemberInRunningChallenge = false;
        }
      });
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/stats/stats.component.ts